/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { $, fd, dl } from '../theme';
import Ic from '../Icon';

const STATUS_COLORS = { offered:'by', accepted:'bg', declined:'br', expired:'b' };

export default function LeaseRenewal({ tenants = [], leases = [] }) {
  const [filter,        setFilter]        = useState('all');
  const [localStatuses, setLocalStatuses] = useState({});

  const pipeline = leases
    .map(l => {
      const tenant = tenants.find(t => t.id === (l.tenant_id || l.tid));
      if (!tenant) return null;
      const days        = dl(l.end_date || l.e);
      const localStatus = localStatuses[l.id];
      const status      = localStatus || (days < 0 ? 'expired' : 'offered');
      if (days > 180 && !localStatus) return null;
      return { lease: l, tenant, days, status };
    })
    .filter(Boolean)
    .sort((a, b) => a.days - b.days);

  const filtered = filter === 'all' ? pipeline : pipeline.filter(x => x.status === filter);

  const setStatus = (id, status) => setLocalStatuses(prev => ({ ...prev, [id]: status }));

  const urgent   = pipeline.filter(x => x.days < 60).length;
  const expiring = pipeline.filter(x => x.days >= 60 && x.days <= 180).length;
  const accepted = pipeline.filter(x => localStatuses[x.lease.id] === 'accepted').length;

  return (
    <div>
      <div className="sg3">
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#f85149,#fc7b7b)' }}/>
          <small>Urgent (under 60d)</small>
          <div className="stv">{urgent}</div>
          <div className="sts">action needed</div>
        </div>
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#d29922,#e8b84b)' }}/>
          <small>Expiring Soon</small>
          <div className="stv">{expiring}</div>
          <div className="sts">60–180 days</div>
        </div>
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#22c55e,#4ade80)' }}/>
          <small>Renewals Accepted</small>
          <div className="stv">{accepted}</div>
          <div className="sts">this session</div>
        </div>
      </div>

      <div className="card">
        <div className="card-hd"><h3>Renewal Pipeline</h3></div>
        <div className="tabs">
          {[['all','All'],['offered','Offered'],['accepted','Accepted'],['declined','Declined'],['expired','Expired']].map(([v, l]) => (
            <button key={v} className={`tab${filter === v ? ' tab-on' : ''}`} onClick={() => setFilter(v)}>{l}</button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <div style={{ textAlign:'center', padding:'40px 20px', color:'#484f58' }}>
            <Ic n="file" s={36} c="#484f58"/>
            <div style={{ marginTop:12, fontSize:13 }}>
              {filter === 'all' ? 'No leases expiring within 180 days.' : `No leases with status "${filter}".`}
            </div>
          </div>
        ) : (
          <div className="tw">
            <table>
              <thead>
                <tr><th>Tenant</th><th>Property / Unit</th><th>Expires</th><th>Rent</th><th>Days Left</th><th>Status</th><th>Action</th></tr>
              </thead>
              <tbody>
                {filtered.map(({ lease: l, tenant: t, days, status }) => {
                  const initials = (t.full_name || t.name || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
                  const rent     = l.monthly_rent || l.rent || 0;
                  return (
                    <tr key={l.id}>
                      <td>
                        <div className="tc">
                          <div className="av" style={{ width:30, height:30, fontSize:10 }}>{initials}</div>
                          <span style={{ fontWeight:500 }}>{t.full_name || t.name}</span>
                        </div>
                      </td>
                      <td>
                        <div style={{ fontSize:13 }}>{l.property || l.p || '—'}</div>
                        <div style={{ fontSize:11, color:'#8b949e' }}>Unit {l.unit || l.u || t.unit || '—'}</div>
                      </td>
                      <td style={{ fontSize:12, color:'#8b949e' }}>{fd(l.end_date || l.e)}</td>
                      <td style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, color:'#4ade80' }}>{$(rent)}</td>
                      <td>
                        <span className={`b ${days < 0 ? 'b' : days < 60 ? 'br' : 'by'}`}>
                          {days < 0 ? 'Expired' : `${days}d`}
                        </span>
                      </td>
                      <td><span className={`b ${STATUS_COLORS[status] || 'b'}`}>{status}</span></td>
                      <td style={{ display:'flex', gap:5 }}>
                        {status === 'accepted' ? (
                          <span style={{ fontSize:12, color:'#22c55e', display:'flex', alignItems:'center', gap:4 }}>
                            <Ic n="check" s={12} c="#22c55e"/>Renewed
                          </span>
                        ) : (
                          <>
                            <button className="btn btn-ok" style={{ padding:'4px 9px', fontSize:11 }} onClick={() => setStatus(l.id, 'accepted')}>Accept</button>
                            {status !== 'declined' && (
                              <button className="btn btn-gh" style={{ padding:'4px 9px', fontSize:11 }} onClick={() => setStatus(l.id, 'declined')}>Decline</button>
                            )}
                          </>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
